// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cf65b1b6","703":"24d60d1c"}[chunkId] + ".chunk.js";
};